function closestElement (elements, x, y) {
  let closestElement = null
  let closestDistance = Infinity
  elements.forEach(element => {
    const distance = Math.hypot(element.getBoundingClientRect().x - x, element.getBoundingClientRect().y - y)
    if (distance < closestDistance) {
      closestElement = element
      closestDistance = distance
    }
  })
  return closestElement
}

export { closestElement }
